import { TabView } from "@grindex-client/components/Tabs/TabView.class";
import { baseLink } from "@grindex-common/helpers/baseLink";
import TabNames from "@grindex-client/components/Tabs/TabNames.class";

function init($views) {
	const tabNames = new TabNames();

	const ROUTES = {
		"/": "products",
		"/all/": "all",
		"/documentsandvideos/": "documentsandvideos",
		"/pages/": "pages",
	};

	$views.forEach(($view) => {
		const tabView = new TabView(baseLink.getBaseLinkWithoutSegments(window.config.search.tabs), ROUTES, $view, true);

		tabView.init(tabNames.freeTextSearchTabs);
	});
}

export default {
	view: "free-text-searchTabs",
	init,
};
